import { Paper, withStyles } from "@material-ui/core"
import React, { cloneElement } from "react"

const styles = (theme) => ({
    paper: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),

        marginBottom: theme.spacing(2),
    },
})

const paperMd = ({ classes, elevation, children }) =>
    <Paper classes={{ root: classes.paper }} elevation={elevation ? parseInt(elevation) : 4}>
        {
            children.filter(c => React.isValidElement(c)).map(c =>
                cloneElement(c, { insidePaper: true }),
            )
        }
    </Paper>

export const PaperMd = withStyles(styles)(paperMd)